import { render, staticRenderFns } from "./addMaterialDrawer.vue?vue&type=template&id=56e32292&scoped=true"
import script from "./addMaterialDrawer.vue?vue&type=script&lang=js"
export * from "./addMaterialDrawer.vue?vue&type=script&lang=js"
import style0 from "./addMaterialDrawer.vue?vue&type=style&index=0&id=56e32292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e32292",
  null
  
)

export default component.exports